/* product.js — PDP interactions (loaded only on product templates, deferred).
   Variant matching + price/image/URL/ATC/sticky sync, image-swap-by-alt for property
   swatches, delivery date/time scheduler (cutoff/lead/prep/blackout), sticky ATC reveal.
   Add-on add/step is owned by cart.js (delegated). */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const API = window.TNE || {};
  const money = API.money || ((c) => c);

  const root = $('[data-product]'); if (!root) return;
  let product = null;
  try { product = JSON.parse($('[data-product-json]', root).textContent); } catch (_) {}

  /* ---------- Variant matching ---------- */
  function currentOptions() { return $$('[data-variant-option]:checked', root).map((i) => i.value); }
  function findVariant() {
    if (!product) return null;
    const opts = currentOptions();
    if (!opts.length) return product.variants.find((v) => v.available) || product.variants[0];
    return product.variants.find((v) => v.options.length === opts.length && v.options.every((o, i) => o === opts[i]));
  }
  /* Swap the main image RELIABLY: the <img> carries a srcset, which the browser prefers over
     .src — so we must clear srcset/sizes or the picture never changes. */
  const setMainImage = (url) => { const m = $('#pdp-main-image', root); if (!m || !url) return; m.removeAttribute('srcset'); m.removeAttribute('sizes'); m.src = url; };
  /* What the ticked extras add, in cents. Shopify can't fold a surcharge into a variant's
     price without variants or a Function, so the extras stay separate cart lines — but the
     customer should still see ONE honest number before they commit. */
  /* Every gift carries its own extras now, so the button always counts what is ticked — there
     is no "already paid for" case to exclude. */
  function extrasCents() {
    let total = 0;
    $$('input[type="checkbox"][data-fee-cents]', root).forEach((cb) => {
      if (cb.checked) total += parseInt(cb.getAttribute('data-fee-cents'), 10) || 0;
    });
    $$('select', root).forEach((sel) => {
      const opt = sel.options[sel.selectedIndex];
      if (opt) total += parseInt(opt.getAttribute('data-fee-cents'), 10) || 0;
    });
    /* Add-on tiles are not form controls, so the two sweeps above miss them. Each selected one
       counts its own price times ITS OWN quantity — deliberately not the gift's. An add-on is its
       own cart line, so ordering six of the main gift does not order six teddy bears; ordering two
       teddy bears is what orders two. */
    $$('[data-addon].is-added', root).forEach((tile) => {
      /* A multi-variant add-on carries a map of variant -> quantity, priced from the dialog's own
         cards. Its data-addon-cents is deliberately 0 in that case, so the two cannot double up. */
      let picks = null;
      try { picks = JSON.parse(tile.getAttribute('data-addon-picks') || 'null'); } catch (_) {}
      if (picks && Object.keys(picks).length) {
        const dlgSel = tile.querySelector('[data-open-target]')?.getAttribute('data-open-target');
        const dlg = dlgSel && dlgSel.length > 1 ? document.querySelector(dlgSel) : null;
        Object.keys(picks).forEach((vid) => {
          const q = picks[vid] | 0; if (q < 1) return;
          const card = dlg && dlg.querySelector(`[data-vopt][data-vid="${vid}"]`);
          total += (parseInt(card?.getAttribute('data-vcents'), 10) || 0) * q;
        });
        return;
      }
      const cents = parseInt(tile.getAttribute('data-addon-cents'), 10) || 0;
      const qty = Math.max(1, parseInt(tile.getAttribute('data-addon-qty') || '1', 10) || 1);
      total += cents * qty;
    });
    /* One topper is already paid for inside the product's price, and the cart gives that unit
       back with a Buy X Get Y discount. The card publishes what it is handing over, and this
       running total subtracts it - otherwise the button quotes a figure the cart then undercuts,
       which is the same disagreement the card's own footer was built to avoid. */
    var freeNode = document.querySelector('[data-topper][data-topper-free-cents]');
    if (freeNode) total -= parseInt(freeNode.getAttribute('data-topper-free-cents'), 10) || 0;
    return total > 0 ? total : 0;
  }

  /* Extras are charged per gift (D-106), so the cart containing one says nothing about THIS
     gift — the box starts unticked every time and the customer opts in per product. */

  function render(v) {
    const idInput = $('#variant-select', root) || $('[name="id"]', root);
    const atc = $('[data-atc]', root);
    const priceWrap = $('[data-price-wrap]', root);
    if (!v) { if (atc) { atc.disabled = true; atc.textContent = (window.theme?.strings?.unavailable) || 'Unavailable'; } return; }
    if (idInput) idInput.value = v.id;
    const total = v.price + extrasCents();
    if (priceWrap) priceWrap.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ` <s class="price__compare">${money(v.compare_at_price)}</s>` : '');
    $$('[data-sticky-price]').forEach((el) => (el.textContent = money(total)));
    if (atc) {
      atc.disabled = !v.available;
      const lbl = atc.dataset.addLabel || 'Add to cart';
      /* The price no longer rides inside this label. It is shown once, above both buttons, so
         Buy now quotes the same number instead of quoting nothing. */
      atc.textContent = v.available ? lbl : (window.theme?.strings?.soldOut || 'Sold out');
    }
    $$('[data-atc-total]').forEach((el) => (el.textContent = money(total)));
    if (v.featured_media) {
      const thumb = v.featured_media.id ? $(`[data-media-id="${v.featured_media.id}"]`, root) : null;
      let full = thumb && thumb.getAttribute('data-full');
      if (!full) {
        const s = v.featured_media.src || (v.featured_media.preview_image && v.featured_media.preview_image.src);
        if (s) full = s.indexOf('width=') > -1 ? s : (s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=900');
      }
      const slide = v.featured_media.id ? $(`[data-slide-media="${v.featured_media.id}"]`, root) : null;
      if (slide) {
        // Slides exist (product may include video) — activate the matching one rather than
        // rewriting a single <img>, which would leave a video slide showing.
        $$('[data-slide]', root).forEach((sl) => {
          const on = sl === slide;
          sl.classList.toggle('is-active', on);
          if (!on) sl.querySelectorAll('video').forEach((vid) => { try { vid.pause(); } catch (e) {} });
        });
        $$('[data-thumb]', root).forEach((t) => t.removeAttribute('aria-current'));
        if (thumb) thumb.setAttribute('aria-current', 'true');
      } else if (full) {
        setMainImage(full);
        $$('[data-thumb]', root).forEach((t) => t.removeAttribute('aria-current'));
        if (thumb) thumb.setAttribute('aria-current', 'true');
      }
    }
    if (history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
  }
  $$('[data-variant-option]', root).forEach((i) => i.addEventListener('change', () => render(findVariant())));

  /* ---------- Photo <-> colour choice, both directions ----------
     Colour here is a line-item property (Balloon colour), not a variant, so Shopify's own
     variant-image switching cannot drive it.

     The previous version was unreachable: nothing in this theme carries data-swap-alt, so the
     helper existed but nothing could ever call it.

     SCORED rather than first-match, and a tie changes nothing: showing the wrong colour is worse
     than showing none, because the shopper believes they have seen what they are buying. */
  const colTokens = (x) => String(x || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(' ').filter(Boolean);
  /* ALT TEXT ONLY, not the filename: filenames here name the flowers rather than the colour
     being chosen, so matching on them would pair a swatch with the wrong photo. */
  const mediaTokens = (m) => colTokens(m.alt);
  const colourInputs = () => $$('input[type="radio"][name^="properties["][name*="colour"], input[type="radio"][name^="properties["][name*="color"]', root);

  function swapByColour() {
    if (!product || !product.media || !product.media.length) return;
    const dims = colourInputs().filter((i) => i.checked && i.value).map((i) => colTokens(i.value));
    if (!dims.length) return;
    let best = null, score = 0, tied = false;
    product.media.forEach((m) => {
      const toks = mediaTokens(m);
      let sc = 0;
      dims.forEach((d) => { if (d.every((t) => toks.indexOf(t) > -1)) sc++; });
      if (sc > score) { score = sc; best = m; tied = false; }
      else if (sc === score && sc > 0 && m !== best) { tied = true; }
    });
    if (!best || score === 0 || tied || !best.src) return;
    setMainImage(best.src.replace(/(\.[a-z]+)(\?|$)/i, '_900x$1$2'));
    /* Keep the strip in step, so the arrows and swipe carry on from the photo on screen. */
    const t = $$('[data-thumb]', root).filter((x) => String(x.getAttribute('data-media-id')) === String(best.id))[0];
    if (t) { $$('[data-thumb]', root).forEach((x) => x.removeAttribute('aria-current')); t.setAttribute('aria-current', 'true'); }
  }

  /* The way back. Choosing a colour moved the photo; moving the photo never moved the colour, so
     a shopper who swiped to the gold balloon still had the first colour in their cart. */
  function syncColourToMedia(mediaId) {
    if (!product || !product.media) return;
    const m = product.media.filter((x) => String(x.id) === String(mediaId))[0];
    if (!m) return;
    const toks = mediaTokens(m);
    colourInputs().forEach((input) => {
      if (input.checked || !input.value) return;
      const d = colTokens(input.value);
      if (!d.length || !d.every((t) => toks.indexOf(t) > -1)) return;
      input.checked = true;
      /* No change event: swapByColour listens on it, and firing it here would send the gallery
         chasing the choice we just made from the gallery. */
    });
  }
  root.addEventListener('change', (e) => {
    const el = e.target;
    if (el && el.matches && el.matches('input[type="radio"][name^="properties["]')) swapByColour();
  });

  /* ---------- Gallery: thumbnail click + prev/next arrows + mobile swipe ---------- */
  (function () {
    const gallery = $('[data-gallery]', root); const main = $('#pdp-main-image', root);
    if (!main) return;
    const thumbs = $$('[data-thumb]', root); if (thumbs.length < 2) return;
    const idx = () => { const i = thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true'); return i < 0 ? 0 : i; };
    const slides = $$('[data-slide]', root);
    const show = (i) => {
      i = (i % thumbs.length + thumbs.length) % thumbs.length;
      const t = thumbs[i];
      if (slides.length) {
        /* Slide-based, so a product can mix photos and video. Anything playing on the slide we
           are leaving gets paused — otherwise audio keeps running from an invisible slide. */
        slides.forEach((sl, idx) => {
          const on = idx === i;
          sl.classList.toggle('is-active', on);
          if (!on) sl.querySelectorAll('video').forEach((v) => { try { v.pause(); } catch (e) {} });
        });
      } else {
        const full = t.getAttribute('data-full');
        if (full) setMainImage(full);
      }
      thumbs.forEach((x) => x.removeAttribute('aria-current'));
      t.setAttribute('aria-current', 'true');
      try { t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (e) {}
      const mid = t.getAttribute('data-media-id');
      if (mid) syncColourToMedia(mid);
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
    $('[data-gallery-prev]', root)?.addEventListener('click', () => show(idx() - 1));
    $('[data-gallery-next]', root)?.addEventListener('click', () => show(idx() + 1));
    // Mobile swipe: horizontal drag on the main image changes the picture
    if (gallery) {
      let x0 = null, y0 = null;
      gallery.addEventListener('touchstart', (e) => { const t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
      gallery.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) show(idx() + (dx < 0 ? 1 : -1));
        x0 = y0 = null;
      }, { passive: true });
    }
  })();

  /* ---------- Sticky ATC reveal (mobile) ---------- */
  const sticky = $('[data-sticky-atc]');
  const form = $('#product-form', root);
  if (sticky && form && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((ents) => ents.forEach((e) => sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0)),
      { rootMargin: '-80px 0px 0px 0px' });
    io.observe(form);
  }

  /* ---------- Delivery scheduler (client hints; capacity enforced server/app-side) ----------
     Every calendar decision here is made in Asia/Dubai, never on the device clock: someone
     browsing from Los Angeles, or with a wrong clock, must still be offered the shop's days. */
  function initScheduler() {
    const sched = $('[data-sched]', root); if (!sched) return;
    const date = $('[data-sched-date]', sched); if (!date) return;
    const cutoff = parseInt(sched.dataset.cutoff || '', 10);
    const lead = parseInt(sched.dataset.lead || '0', 10);
    const maxDays = parseInt(sched.dataset.max || '60', 10);
    /* Stamped onto the scheduler so "is my deploy live?" is answerable from the page rather than
       by comparing minified bytes. Bump it by hand whenever this file changes. */
    sched.dataset.build = '2026-09-28a';
    const slotGuard = parseInt(sched.dataset.slotGuard || '', 10) || 30;
    const midGuard = parseInt(sched.dataset.midnightGuard || '', 10) || 30;
    const blackoutDays = (sched.dataset.blackoutDays || '').toLowerCase().split(',').map((s) => s.trim()).filter(Boolean);
    const blackoutDates = (sched.dataset.blackoutDates || '').split(',').map((s) => s.trim()).filter(Boolean);
    const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

    /* Dubai "now" as a calendar date + minutes past its midnight. 'en-CA' already emits
       ISO-ordered parts, so there is no Date round-trip — and none would be safe: building a
       Date back out of a localised string reads the DEVICE calendar again, which is the bug
       this replaces. */
    const dubaiNow = () => {
      const p = {};
      new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Dubai', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date()).forEach((x) => { p[x.type] = x.value; });
      return { iso: `${p.year}-${p.month}-${p.day}`, minutes: (Number(p.hour) % 24) * 60 + Number(p.minute) };
    };
    /* Date maths on the calendar string via UTC, so no timezone ever enters it. */
    const shift = (iso, n) => { const [y, m, d] = iso.split('-').map(Number); return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10); };
    const daysBetween = (a, b) => {
      const [ay, am, ad] = a.split('-').map(Number); const [by, bm, bd] = b.split('-').map(Number);
      return Math.round((Date.UTC(ay, am - 1, ad) - Date.UTC(by, bm - 1, bd)) / 86400000);
    };
    const weekdayOf = (iso) => { const [y, m, d] = iso.split('-').map(Number); return new Date(Date.UTC(y, m - 1, d)).getUTCDay(); };

    const opening = dubaiNow();
    let minLead = lead;
    if (!isNaN(cutoff) && Math.floor(opening.minutes / 60) >= cutoff && lead === 0) minLead = 1;
    date.min = shift(opening.iso, minLead);
    date.max = shift(opening.iso, maxDays);

    /* A PAUSE closes a run of days without closing the shop. Shopify's own controls are
       all-or-nothing — pausing the store or password-protecting it stops every order,
       including ones for dates you could still deliver. This blocks delivery on or before
       the paused date and leaves everything after it open.

       A date already in the past is ignored, so a forgotten setting quietly stops mattering
       rather than blocking the calendar forever. */
    /* Store-wide and per-product pauses, whichever ends LATER. A product may be closed for
       longer than the shop; it may not reopen earlier than a store-wide closure.

       Each carries an optional TIME. Without one the pause means the whole of that day and
       deliveries resume the next morning. With one it means "until that moment", so slots later
       the same day stay bookable — which is what "closed until Monday evening" actually means. */
    const isDate = (v) => /^\d{4}-\d{2}-\d{2}$/.test(v);
    const asMinutes = (hhmm) => {
      const m = /^(\d{1,2}):(\d{2})$/.exec((hhmm || '').trim());
      return m ? Number(m[1]) * 60 + Number(m[2]) : null;
    };
    const pauseCandidates = [
      { d: (sched.dataset.pauseUntil || '').trim(), t: asMinutes(sched.dataset.pauseTime) },
      { d: (sched.dataset.pauseUntilProduct || '').trim(), t: asMinutes(sched.dataset.pauseTimeProduct) }
    ]
      .filter((c) => isDate(c.d))
      /* A pause whose moment has already passed is spent. Without a time that means the whole
         day has to be behind us; with one, only that minute. */
      .filter((c) => {
        const dd = daysBetween(c.d, opening.iso);
        if (dd > 0) return true;
        if (dd < 0) return false;
        return c.t === null || opening.minutes < c.t;
      })
      .sort((a, b) => (daysBetween(a.d, b.d) || ((a.t === null ? 1440 : a.t) - (b.t === null ? 1440 : b.t))));
    const active = pauseCandidates[pauseCandidates.length - 1] || null;
    const pauseUntil = active ? active.d : '';
    const pauseTime = active ? active.t : null;
    const paused = !!pauseUntil;
    /* A time later than the last slot of the day closes every slot on it. Left as-is the date
       stayed pickable with the whole list greyed out, which reads as broken — so a pause that
       leaves nothing bookable is treated as a full-day pause and the calendar moves on.

       This also means a merchant does not need a second, date-only metafield: setting 11:59 PM
       on a Date-and-time field simply means "all of that day". */
    const latestSlotStart = (() => {
      const sel = sched.querySelector('[data-sched-time]');
      if (!sel) return null;
      let best = null;
      Array.from(sel.options).forEach((o) => {
        if (!o.value) return;
        const m = /(\d{1,2}):(\d{2})\s*(AM|PM|ص|م)?/i.exec(String(o.value));
        if (!m) return;
        let h = parseInt(m[1], 10); const mm = parseInt(m[2], 10);
        const raw = (m[3] || '').toUpperCase();
        const ap = raw === 'ص' ? 'AM' : raw === 'م' ? 'PM' : raw;
        if (ap === 'PM' && h < 12) h += 12; if (ap === 'AM' && h === 12) h = 0;
        const v = h * 60 + mm;
        if (best === null || v > best) best = v;
      });
      return best;
    })();
    const closesWholeDay = pauseTime !== null && latestSlotStart !== null && pauseTime > latestSlotStart;

    if (paused) {
      /* With a time, the paused DAY itself is still bookable — just not before that hour, which
         updateSlots enforces. Without one, or when nothing is left bookable, the whole day goes. */
      const resume = (pauseTime === null || closesWholeDay) ? shift(pauseUntil, 1) : pauseUntil;
      if (daysBetween(resume, date.min) > 0) date.min = resume;
      const chosenGap = date.value ? daysBetween(date.value, pauseUntil) : null;
      if (chosenGap !== null && (chosenGap < 0 || (chosenGap === 0 && (pauseTime === null || closesWholeDay)))) date.value = '';
    }

    const validate = () => {
      const v = date.value; if (!v) { date.setCustomValidity(''); return; }
      let msg = '';
      if (blackoutDays.includes(dayNames[weekdayOf(v)])) msg = sched.getAttribute('data-msg-blackout-day') || 'We don’t deliver on that day — please choose another.';
      if (blackoutDates.includes(v)) msg = sched.getAttribute('data-msg-blackout-date') || 'That date is unavailable — please choose another.';
      /* Typed dates bypass the picker's min, so the pause is enforced here too. */
      if (paused && (daysBetween(v, pauseUntil) < 0 || (daysBetween(v, pauseUntil) === 0 && (pauseTime === null || closesWholeDay)))) {
        msg = pauseMessage();
      }
      date.setCustomValidity(msg);
    };

    /* Pin the calendar and the digits. Without -ca-gregory some Arabic devices render the Hijri
       date and without -nu-latn they render Eastern Arabic numerals — either way the customer
       cannot match what they read here against the Gregorian date in their order email. */
    const lang = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
    const dateOpts = { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' };
    let fmt;
    try { fmt = new Intl.DateTimeFormat(lang.indexOf('ar') === 0 ? 'ar-u-ca-gregory-nu-latn' : lang, dateOpts); }
    catch (e) { fmt = new Intl.DateTimeFormat('en', dateOpts); }
    const human = (iso) => { const [y, m, d] = iso.split('-').map(Number); return fmt.format(new Date(Date.UTC(y, m - 1, d))); };

    /* The wording follows the shape of the pause. With a time, the paused day IS the earliest
       day, so the old sentence named the same date twice — "not delivering until Wed Sep 2. The
       earliest date you can choose is Wed Sep 2." — and never mentioned the hour that was
       actually set. */
    const humanTime = (mins) => {
      const d = new Date(Date.UTC(2000, 0, 1, Math.floor(mins / 60), mins % 60));
      try {
        return new Intl.DateTimeFormat(lang.indexOf('ar') === 0 ? 'ar-u-nu-latn' : lang,
          { hour: 'numeric', minute: '2-digit', timeZone: 'UTC' }).format(d);
      } catch (_) {
        return String(Math.floor(mins / 60)).padStart(2, '0') + ':' + String(mins % 60).padStart(2, '0');
      }
    };
    const pauseMessage = () => ((pauseTime === null || closesWholeDay)
      ? (sched.getAttribute('data-msg-paused') || '')
          .replace('%DATE%', human(pauseUntil)).replace('%NEXT%', human(date.min))
      : (sched.getAttribute('data-msg-paused-time') || '')
          .replace('%TIME%', humanTime(pauseTime)).replace('%DATE%', human(pauseUntil)));

    /* Say it up front, not only when they pick a blocked date. Someone who opens the page
       during a pause should learn it before choosing, not after being refused. */
    if (paused) {
      const note = $('[data-sched-pause]', sched) || $('[data-sched-pause]', root);
      if (note) {
        note.textContent = pauseMessage();
        note.hidden = !note.textContent;
      }
    }

    /* Fill %DATE% / %NIGHT% / %NEXT% into an element, each value in its own <bdi dir="ltr">.
       Built with createElement/textContent — never innerHTML, and never markup inside a
       translation string. Unisolated, "1 Jan 2027" reorders inside an Arabic sentence and the
       day number ends up beside the wrong year. */
    const paint = (el, tpl, vals) => {
      el.textContent = '';
      String(tpl).split(/(%DATE%|%NIGHT%|%NEXT%)/).forEach((chunk) => {
        if (chunk === '%DATE%' || chunk === '%NIGHT%' || chunk === '%NEXT%') {
          const b = document.createElement('bdi');
          b.setAttribute('dir', 'ltr');
          b.textContent = vals[chunk.slice(1, -1).toLowerCase()] || '';
          el.appendChild(b);
        } else if (chunk) el.appendChild(document.createTextNode(chunk));
      });
    };

    const timeSel = $('[data-sched-time]', sched);
    const dispatch = $('[data-dispatch-date]', sched);
    const midFlag  = $('[data-midnight-flag]', sched);
    const selectedOpt = () => (timeSel && timeSel.selectedIndex >= 0 ? timeSel.options[timeSel.selectedIndex] : null);
    const isMidnight = (opt) => !!(opt && opt.hasAttribute('data-midnight'));
    const startMinutes = (label) => {
      /* Arabic slot labels keep Western digits but use ص / م for AM / PM. Without those the
         regex left `ap` empty and "3:00 م" parsed as 03:00, so the afternoon slot's cut-off was
         computed twelve hours early on the Arabic store. */
      const m = String(label).match(/(\d{1,2}):(\d{2})\s*(AM|PM|ص|م)?/i);
      if (!m) return null;
      let h = parseInt(m[1], 10); const mm = parseInt(m[2], 10);
      const raw = (m[3] || '').toUpperCase();
      const ap = raw === 'ص' ? 'AM' : raw === 'م' ? 'PM' : raw;
      if (ap === 'PM' && h < 12) h += 12; if (ap === 'AM' && h === 12) h = 0;
      return h * 60 + mm;
    };

    /* Dispatch date rides on EVERY line for EVERY slot — same day as the delivery, or the day
       before for midnight — so the run sheet is one filter with no exception to remember. */
    const syncDispatch = () => {
      if (!dispatch) return;
      const v = date.value;
      dispatch.value = v ? (isMidnight(selectedOpt()) ? shift(v, -1) : v) : '';
    };

    /* The cart has to know "is this line a midnight delivery?" without reading the slot TEXT,
       which is merchant-editable and therefore Arabic on /ar. data-midnight is set by Liquid from
       the keyword match, so this flag is correct in every language. */
    const syncMidnightFlag = () => {
      if (!midFlag) return;
      midFlag.value = isMidnight(selectedOpt()) ? '1' : '';
    };

    if (timeSel) {
      /* A slot closes `guard` minutes before it starts, measured on the Dubai clock ACROSS days.
         The old rule only ran when the chosen date was today, which made it structurally unable
         to guard midnight: a midnight slot is only ever bookable on a date that ISN'T today, so
         the check never fired and 00:00 could be bought 15 minutes beforehand. */
      const closesAt = (opt, chosenIso, now) => {
        const s = startMinutes(opt.value);
        if (s === null) return null;
        return daysBetween(chosenIso, now.iso) * 1440 + s - (isMidnight(opt) ? midGuard : slotGuard);
      };
      const updateSlots = () => {
        const now = dubaiNow();
        const chosen = date.value;
        Array.from(timeSel.options).forEach((opt) => {
          if (!opt.value) return;
          let disable = false;
          if (chosen) { const t = closesAt(opt, chosen, now); if (t !== null && now.minutes >= t) disable = true; }
          /* On the day a timed pause ends, slots that begin before it are closed — that is the
             difference between "closed all Monday" and "closed until Monday evening". */
          if (paused && pauseTime !== null && chosen && daysBetween(chosen, pauseUntil) === 0) {
            const st = startMinutes(opt.value);
            if (st !== null && st < pauseTime) disable = true;
          }
          opt.disabled = disable;
          if (disable && opt.selected) timeSel.value = '';
        });
      };

      /* The surcharge note. Amount comes from the <option>, which the section rendered from the
         fee product — nothing about the price is hard-coded here. */
      const feeNote = $('[data-slot-fee-note]', sched);
      const noteTpl = sched.getAttribute('data-fee-note') || '';
      const syncFee = () => {
        if (!feeNote) return;
        const price = selectedOpt() && selectedOpt().getAttribute('data-fee-price');
        if (price) { feeNote.textContent = noteTpl || ('+ ' + price); feeNote.hidden = false; }
        else { feeNote.textContent = ''; feeNote.hidden = true; }
      };

      /* Which night is this? Deliberately its own element, not part of the fee note: it has to
         keep answering that question even when there is no surcharge to announce. */
      const readback = $('[data-midnight-readback]', sched);
      const S = {
        confirm: sched.getAttribute('data-mn-confirm') || '',
        nodate: sched.getAttribute('data-mn-nodate') || '',
        passed: sched.getAttribute('data-mn-passed') || '',
        toolate: sched.getAttribute('data-mn-toolate') || ''
      };
      const nextMidnight = (now) => {
        for (let i = 0; i <= 400; i++) {
          const d = shift(now.iso, i);
          if (daysBetween(d, now.iso) * 1440 - midGuard > now.minutes) return d;
        }
        return shift(now.iso, 1);
      };
      const syncNight = () => {
        if (!readback) return;
        if (!isMidnight(selectedOpt())) {
          /* Midnight exists but is greyed out for the chosen date — say WHY and name the next
             one we can actually reach. Previously this message was unreachable: it only ran when
             midnight was SELECTED, and you cannot select a disabled option. */
          const midOpt = timeSel.querySelector('option[data-midnight]');
          if (midOpt && midOpt.disabled && date.value) {
            const now = dubaiNow();
            readback.hidden = false;
            paint(readback, daysBetween(date.value, now.iso) <= 0 ? S.passed : S.toolate,
                  { date: human(date.value), next: human(nextMidnight(now)) });
            return;
          }
          readback.hidden = true; readback.textContent = ''; return;
        }
        readback.hidden = false;
        const chosen = date.value;
        if (!chosen) { readback.textContent = S.nodate; return; }
        const now = dubaiNow();
        const gap = daysBetween(chosen, now.iso) * 1440 - midGuard;
        if (now.minutes >= gap) {
          paint(readback, daysBetween(chosen, now.iso) <= 0 ? S.passed : S.toolate,
                { date: human(chosen), next: human(nextMidnight(now)) });
          return;
        }
        paint(readback, S.confirm, { date: human(chosen), night: human(shift(chosen, -1)) });
      };

      const sync = () => { updateSlots(); syncFee(); syncNight(); syncDispatch(); syncMidnightFlag(); };
      timeSel.addEventListener('change', () => { syncFee(); syncNight(); syncDispatch(); syncMidnightFlag(); });
      date.addEventListener('input', () => { validate(); sync(); });
      date.addEventListener('change', () => { validate(); sync(); });
      setInterval(sync, 60000);
      validate(); sync();

        /* PRESELECT THE NEXT AVAILABLE DATE AND SLOT. Both are required and both shipped empty, so
           the first press of Add to cart was always a validation error - and it also swallowed the
           free-topper prompt, which stands aside for an invalid form. date.min is already the
           earliest date every rule above agrees on (lead, cut-off, pause), so it is the honest
           starting point; validate() then rejects it if a blackout lands exactly there, and we
           step forward a day at a time. Filled only when empty, so a shopper's own choice is never
           overwritten. */
        if (!date.value) {
          let pick = date.min;
          for (let i = 0; i <= 400; i++) {
            if (date.max && pick > date.max) { pick = ''; break; }
            date.value = pick;
            validate();
            if (date.checkValidity()) break;
            pick = shift(pick, 1);
          }
          if (!date.value || !date.checkValidity()) { date.value = ''; }
          validate(); sync();
        }
        /* After sync(), so a slot that has already closed today is never the default. */
        if (timeSel && !timeSel.value) {
          const openSlot = Array.from(timeSel.options).find((o) => o.value && !o.disabled);
          if (openSlot) { timeSel.value = openSlot.value; syncFee(); syncNight(); syncDispatch(); syncMidnightFlag(); }
        }
    } else {
      date.addEventListener('input', () => { validate(); syncDispatch(); syncMidnightFlag(); });
      date.addEventListener('change', () => { validate(); syncDispatch(); syncMidnightFlag(); });
      validate(); syncDispatch(); syncMidnightFlag();
    }
  }

  /* ---------- Cake flavour picker (image tiles, horizontally scrollable) ---------- */
  function initFlavours() {
    const pick = $('[data-flavourpick]', root); if (!pick) return;
    const err = $('[data-flavour-error]', root);
    const radios = $$('[data-flavour]', pick);
    const mark = () => $$('.flavourpick__opt', pick).forEach((o) => o.classList.toggle('is-on', !!o.querySelector('input')?.checked));
    pick.addEventListener('change', () => {
      mark();
      if (err) err.hidden = true;
      // Keep the chosen tile in view — the strip scrolls, so a keyboard pick can land off-screen.
      const on = pick.querySelector('input:checked');
      if (on) { try { on.closest('.flavourpick__opt').scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (e) {} }
    });
    // Native `required` on a radio inside a scroller can fail to anchor its bubble, so show
    // our own message too (the form still refuses to submit either way).
    radios.forEach((r) => r.addEventListener('invalid', () => {
      if (err) err.hidden = false;
      try { pick.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    }));
    mark();
  }

  /* ---------- Photo upload (native Shopify line-item property file) ----------
     One property per file, so several slots. Only the first is visible; the next appears as
     each is filled, up to the configured maximum. Empty slots send nothing (cart.js strips
     empty file parts), so they never create blank properties on the order. */
  /* ---------- Photo dialogs ----------
     One implementation drives both: the paid ADD-ON (any product, priced per photo) and a
     product tagged photo-upload / photo-required (photos are part of the product, no price).
     They differ only in whether there is a tile to price; the upload, list, removal and commit
     are identical, so they are not written twice.

     Two Shopify constraints shape it. One line-item property holds ONE file, so a multi-select
     is fanned out into one hidden input per photo. And files are accepted only from a multipart
     POST of the product form, while a dialog must live outside that form — so the inputs are
     written into a hidden store inside the form when the dialog is applied. */
  /* View all: the grid shows eight and hides the rest, so a long add-ons collection does not
     push the buy button down the page. Reveals rather than paginates — there is nothing to
     fetch, the tiles are already rendered. */
  function initAddonsMore() {
    const btn = $('[data-addons-more]', root);
    if (!btn) return;
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      $$('[data-addon-extra]', root).forEach((el) => { el.hidden = open; });
      btn.setAttribute('aria-expanded', String(!open));
      btn.textContent = open ? (btn.dataset.more || 'View all') : (btn.dataset.less || 'Show less');
    });
  }

  function initPhotoDialogs() {
    if (typeof DataTransfer === 'undefined') return;
    document.querySelectorAll('[data-photo-panel]').forEach(setupPhotoPanel);
  }

  function setupPhotoPanel(panel) {
    const modal = panel.closest('.addonmodal') || panel.closest('[role="dialog"]');
    const store = document.querySelector(panel.getAttribute('data-store') || '');
    if (!modal || !store) return;

    const tileSel = panel.getAttribute('data-tile');
    const tile = tileSel ? document.querySelector(tileSel) : null;
    const picker = panel.querySelector('[data-photo-picker]');
    const listEl = panel.querySelector('[data-photo-files]');
    const countEl = panel.querySelector('[data-photo-count]');
    const errEl = panel.querySelector('[data-photo-error]');
    const subEl = modal.querySelector('[data-photo-total]');
    const unit = parseInt(panel.getAttribute('data-unit-cents') || '0', 10) || 0;
    const maxMb = parseFloat(panel.getAttribute('data-max-mb') || '15') || 15;
    const removeLabel = panel.getAttribute('data-msg-remove') || 'Remove';
    const countTpl = panel.getAttribute('data-count-tpl') || '%N%';
    const summaryTpl = panel.getAttribute('data-summary-tpl') || countTpl;
    /* A safety limit, not a target. Someone selecting a whole folder by accident should be
       told, not silently handed a request that will time out. 0 disables it. */
    const cap = parseInt(panel.getAttribute('data-cap') || '0', 10) || 0;
    /* The product's own photos and the add-on's are both line-item properties on the same
       order, so they cannot share a name — "Photo 1" written twice would overwrite. */
    const prop = panel.getAttribute('data-prop') || 'Photo';
    /* An add-on whose price comes from its VARIANT must not have its quantity rewritten by the
       photo count — one image on a 45cm print is still one 45cm print. */
    const prices = panel.getAttribute('data-prices') !== 'false';
    /* The product dialog's trigger doubles as its status line. */
    const openBtn = document.querySelector('[data-photo-open]');
    const openLabel = document.querySelector('[data-photo-openlabel]');
    const formErr = document.querySelector('[data-photo-formerror]');

    let files = [];
    const say = (m) => { if (!errEl) return; errEl.textContent = m || ''; errEl.hidden = !m; };
    const money = (c) => (API && API.money ? API.money(c) : String(c / 100));

    const ok = (f) => {
      if (f.size > maxMb * 1024 * 1024) {
        say((panel.getAttribute('data-msg-large') || 'That photo is too large (max {mb} MB).').replace('{mb}', maxMb));
        return false;
      }
      if (f.type && f.type.indexOf('image/') !== 0) {
        say(panel.getAttribute('data-msg-type') || 'Please choose an image file.');
        return false;
      }
      return true;
    };

    const paint = () => {
      listEl.textContent = '';
      files.forEach((f, i) => {
        const row = document.createElement('div');
        row.className = 'photorow';
        const name = document.createElement('span');
        name.className = 'photorow__name';
        name.textContent = f.name;
        const rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'photorow__remove';
        rm.setAttribute('data-photo-drop', String(i));
        rm.setAttribute('aria-label', removeLabel + ' ' + f.name);
        rm.textContent = '×';
        row.appendChild(name); row.appendChild(rm);
        listEl.appendChild(row);
      });
      if (countEl) countEl.textContent = '';
      if (subEl) {
        /* Count and price on one pinned line. Under the list they scrolled away exactly when
           the customer was adding photos. */
        subEl.textContent = files.length
          ? summaryTpl.replace('%N%', files.length).replace('%TOTAL%', unit ? money(unit * files.length) : '')
          : '';
        subEl.hidden = !files.length;
      }
    };

    picker.addEventListener('change', () => {
      say('');
      let hitCap = false;
      [...(picker.files || [])].forEach((f) => {
        if (cap && files.length >= cap) { hitCap = true; return; }
        if (ok(f)) files.push(f);
      });
      /* Said AFTER the loop so it is not overwritten by a per-file message, and so picking 150
         at once reports the cap rather than silently keeping the first hundred. */
      if (hitCap) {
        say((panel.getAttribute('data-msg-cap') || 'You can add up to %MAX% photos.').replace('%MAX%', String(cap)));
      }
      /* Cleared so re-picking a file you just removed still fires change. */
      picker.value = '';
      paint();
    });

    listEl.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-photo-drop]');
      if (!btn) return;
      e.preventDefault();
      files.splice(parseInt(btn.getAttribute('data-photo-drop'), 10), 1);
      say(''); paint();
    });

    /* Writing the store is what actually puts the photos on the order. */
    const commit = () => {
      /* If this dialog has variant cards and none is chosen, cart.js is about to refuse the
         apply — so the photo must not be attached either, or the order would carry an image for
         something that was never added. */
      const grid = modal.querySelector('.addonmodal__grid');
      if (grid) {
        let picked = 0;
        modal.querySelectorAll('[data-vopt]').forEach((c) => { picked += parseInt(c.getAttribute('data-vqty') || '0', 10) || 0; });
        if (!picked) return;
      }
      store.textContent = '';
      files.forEach((f, i) => {
        const inp = document.createElement('input');
        inp.type = 'file';
        inp.name = 'properties[' + prop + ' ' + (i + 1) + ']';
        const dt = new DataTransfer(); dt.items.add(f); inp.files = dt.files;
        store.appendChild(inp);
      });
      const n = files.length;

      if (tile && prices) {
        /* Priced per photo: quantity IS the count, which is also what keeps the Add to cart
           total right without a second price to maintain. */
        tile.setAttribute('data-addon-qty', String(n || 1));
        tile.classList.toggle('is-added', n > 0);
        tile.querySelector('[data-addon-toggle]')?.setAttribute('aria-pressed', String(n > 0));
        const price = tile.querySelector('[data-addon-price]');
        if (price) price.textContent = n ? '+ ' + money(unit * n) : (price.getAttribute('data-default') || '');
        const cta = tile.querySelector('[data-addon-cta]');
        if (cta) cta.textContent = n ? countTpl.replace('%N%', n).replace('%MAX%', '') : (cta.getAttribute('data-default') || '');
      }
      if (tile && !prices && n) {
        /* Attaching an image is a choice, so the tile should read as chosen — but the variant
           cards own the quantity and the price, and this must not touch either. */
        tile.classList.add('is-added');
        tile.querySelector('[data-addon-toggle]')?.setAttribute('aria-pressed', 'true');
      }
      if (openLabel) openLabel.textContent = n ? countTpl.replace('%N%', n).replace('%MAX%', '') : '';
      if (formErr && n) formErr.hidden = true;

      if (typeof render === 'function') render(typeof findVariant === 'function' ? findVariant() : undefined);
    };

    modal.addEventListener('click', (e) => {
      if (e.target.closest('[data-addon-apply], [data-photo-apply]')) { commit(); return; }
      if (e.target.closest('[data-addon-clear], [data-photo-clear]')) { files = []; say(''); paint(); commit(); }
    });

    /* photo-required: the store is the source of truth, so guard the submit on it rather than
       on a `required` input that is hidden and therefore unvalidatable. Capture phase, so this
       runs before cart.js's own submit handler starts building the request. */
    const need = store.getAttribute('data-photo-required');
    if (need) {
      const form = $('#product-form', root);
      form?.addEventListener('submit', (e) => {
        if (store.querySelector('input[type="file"]')) return;
        e.preventDefault(); e.stopPropagation();
        if (formErr) { formErr.textContent = need; formErr.hidden = false; }
        openBtn?.focus();
      }, true);
    }

    paint();
  }

  /* ---------- Gift toggle + message-card live preview ---------- */
  function initGift() {
    const toggle = $('[data-gift-toggle]', root); if (!toggle) return;
    const fields = $('[data-gift-fields]', root);
    const setMode = (gift) => {
      if (fields) {
        fields.hidden = !gift;
        fields.querySelectorAll('input, textarea, select').forEach((i) => { i.disabled = !gift; });
      }

    };
    toggle.addEventListener('change', () => setMode(toggle.checked));
    setMode(toggle.checked);
    // live preview: message text + selected card design
    const msg = $('[data-cardmsg]', root), prev = $('[data-card-preview]', root), pimg = $('[data-card-preview-img]', root);
    msg?.addEventListener('input', () => { if (prev) prev.textContent = msg.value; });
    $('[data-carddesign]', root)?.addEventListener('change', (e) => {
      const r = e.target.closest('input[data-card-src]');
      if (r && pimg) pimg.src = r.getAttribute('data-card-src');
      $$('[data-carddesign] .cardpick__opt', root).forEach((o) => o.classList.toggle('is-on', o.querySelector('input')?.checked));
    });
  }

  /* ---------- Quantity stepper ([data-qty] with -/+ buttons + name="quantity") ---------- */
  function initQty() {
    const q = $('[data-qty]', root); if (!q) return;
    const input = $('input[name="quantity"]', q); if (!input) return;
    const val = () => parseInt(input.value, 10) || 1;
    $('[data-qty-dec]', q)?.addEventListener('click', () => { input.value = Math.max(1, val() - 1); });
    $('[data-qty-inc]', q)?.addEventListener('click', () => { input.value = val() + 1; });
    input.addEventListener('change', () => { input.value = Math.max(1, val()); });
  }

  function init() {
    /* Every step isolated, same lesson as theme.js's boot(): these used to run as one sequence,
       so a throw in any of them silently killed everything after it — which is why the flavour
       arrows never initialised even though the code and the markup were both correct and live.
       A failure now costs only its own feature and names itself in the console. */
    const steps = [
      ['flavourArrows', initFlavourArrows],
      ['variant', () => render(findVariant())],
      ['scheduler', initScheduler],
      ['gift', initGift],
      ['qty', initQty],
      ['flavours', initFlavours],
      ['photoDialogs', initPhotoDialogs],
      ['addonsMore', initAddonsMore],
      ['reprice', () => {
        /* Delegated on the whole form: binding to two specific controls meant any control that
           was re-rendered, or added later, stopped updating the button total. */
        const form = $('#product-form', root);
        (form || root).addEventListener('change', () => render(findVariant()));
      }]
    ];
    steps.forEach(([name, fn]) => { try { fn(); } catch (e) { console.error('[pdp] ' + name + ' failed:', e); } });
  }

  /* ---------- Flavour strip arrows (self-contained, Affy-style) ----------
     Deliberately NOT wired through theme.js's shared carousel init: that runs inside one boot
     chain, and anything throwing earlier in that chain silently took the arrows with it. This
     owns its own listeners, coalesces measurement into a rAF (read layout, then write, so no
     forced reflow), and re-measures on load, resize, image arrival and container resize —
     scrollWidth is not trustworthy on the first frame. */
  function initFlavourArrows() {
    const car = $('[data-flavour-car]', root); if (!car) return;
    const row = $('.flavourpick', car); if (!row) return;
    const prev = $('[data-carousel-prev]', car), next = $('[data-carousel-next]', car);
    const rtl = () => getComputedStyle(row).direction === 'rtl';
    let raf = 0;
    /* Belt and braces after several failed attempts at this: set the state THREE ways, so the
       arrow ends up correct whichever one is misbehaving — the .disabled property, the matching
       content attribute, and data-at-start/data-at-end on the container for CSS to key off. */
    const apply = () => {
      const sw = row.scrollWidth, cw = row.clientWidth, sl = Math.abs(row.scrollLeft);
      const scrolls = sw > cw + 4;
      const atStart = sl <= 4, atEnd = sl >= sw - cw - 4;
      car.classList.toggle('is-static', !scrolls);
      car.toggleAttribute('data-at-start', atStart);
      car.toggleAttribute('data-at-end', atEnd);
      if (prev) { prev.disabled = atStart; prev.toggleAttribute('disabled', atStart); }
      if (next) { next.disabled = atEnd; next.toggleAttribute('disabled', atEnd); }
    };
    const update = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = 0; apply(); });
    };
    const nudge = (dir) => row.scrollBy({ left: (rtl() ? -dir : dir) * Math.max(row.clientWidth * 0.8, 160), behavior: 'smooth' });
    prev?.addEventListener('click', () => nudge(-1));
    next?.addEventListener('click', () => nudge(1));
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    $$('img', row).forEach((im) => { if (!im.complete) im.addEventListener('load', update, { once: true }); });
    if (window.ResizeObserver) new ResizeObserver(update).observe(row);
    apply();                       // synchronous first pass — rAF can be starved in a background tab
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* ---- Reviews: a real #reviews anchor above the Judge.me widget + a one-click
     "share for review" button (copies the product URL + #reviews). The widget is a
     Judge.me app block in a separate section, so we enhance it from here. The button
     label never changes; a transient status announces the copy so you can copy again. ---- */
  (function () {
    const S = {
      title: root.getAttribute('data-reviews-title') || 'Customer Reviews',
      share: root.getAttribute('data-reviews-share') || 'Share for review',
      copied: root.getAttribute('data-reviews-copied') || 'Review link copied',
      self: root.getAttribute('data-reviews-selflink') || 'Copy link to reviews'
    };
    const findWidget = () => $('.jdgm-review-widget') || $('#judgeme_product_reviews') || $('.jdgm-rev-widg') || $('[id^="judgeme"]');
    const reviewUrl = () => location.origin + location.pathname + '#reviews';
    function fallbackCopy(t) { const a = document.createElement('textarea'); a.value = t; a.setAttribute('readonly', ''); a.style.cssText = 'position:absolute;left:-9999px'; document.body.appendChild(a); a.select(); try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(a); }
    function copy(t, cb) { if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(t).then(cb, () => { fallbackCopy(t); cb(); }); } else { fallbackCopy(t); cb(); } }
    /* Hide Judge.me's own "Customer Reviews" title so ours is the only heading. Class-based
       first (safe, doc-wide); text-match fallback scoped to the widget; observed for async render. */
    let tries = 0;
    function build() {
      if (document.getElementById('reviews')) return;
      const w = findWidget();
      if (!w) { if (tries++ < 40) setTimeout(build, 250); return; }
      const anchor = document.createElement('span'); anchor.id = 'reviews'; anchor.className = 'pdp-reviews__anchor';
      w.parentNode.insertBefore(anchor, w);
      /* Only the Share button — the widget keeps its own "Customer Reviews" heading (no duplicate). */
      const bar = document.createElement('div'); bar.className = 'pdp-reviews__share';
      const btn = document.createElement('button'); btn.type = 'button'; btn.className = 'pdp-reviews__sharebtn';
      const lbl = document.createElement('span'); lbl.textContent = S.share;
      btn.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>';
      btn.appendChild(lbl);
      const status = document.createElement('span'); status.className = 'pdp-reviews__status'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
      const actions = document.createElement('div'); actions.className = 'pdp-reviews__actions'; actions.appendChild(status); actions.appendChild(btn);
      bar.appendChild(actions);
      w.parentNode.insertBefore(bar, w);
      let reset;
      btn.addEventListener('click', () => copy(reviewUrl(), () => {
        status.textContent = S.copied + ' ✓'; status.classList.add('is-show');
        clearTimeout(reset); reset = setTimeout(() => status.classList.remove('is-show'), 1800);
      }));
      if (location.hash === '#reviews') { try { anchor.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { anchor.scrollIntoView(); } }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
  })();
})();
